<button mat-mini-fab color="primary" (click)="scrollToTop()" aria-label="Zum Anfang der Seite">
    <mat-icon>arrow_upward</mat-icon>
</button>
